const CHANGE_FILTER = 'realhub/brandhub/reportPageFilters/CHANGE_FILTER'
const CHANGE_MULTIPLE_FILTERS = 'realhub/brandhub/reportPageFilters/CHANGE_MULTIPLE_FILTERS'

// Initial State
const initialState = {
  filterAgencyId: 'all',
  filterServiceId: 'all',
  filterPublicationId: 'all',
  filterDaysNumber: '93',
}

// Actions
export function changeFilter(name, value){
  return {
    type: CHANGE_FILTER,
    name,
    value,
  }
}

export function changeMultipleFilters(filters = {}){
  return {
    type: CHANGE_MULTIPLE_FILTERS,
    filters,
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type, filters } = action

  switch (type){
    case CHANGE_FILTER:{
      return { ...state, [action.name]: action.value }
    }
    case CHANGE_MULTIPLE_FILTERS:{
      return { ...state, ...filters }
    }
    default:
      return state
  }
}
